import { IconButton, IconName } from "@/components/common";
import { BaseTableActionProps } from "..";

interface Props extends BaseTableActionProps {
  icon?: IconName;
  disabled?: boolean;
}

export const TableDelete = ({ icon = "Delete", ...props }: Readonly<Props>) => {
  return <IconButton {...props} icon={icon} iconClassName="text-error" aria-label="Deletar" />;
};
